import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaqFooterComponent } from '../../faq/faq-footer/faq-footer.component';
import { FooterComponent } from '../../footer/footer.component';
import { HeaderComponent } from '../../header/header.component';
import { SupportButtonsComponent } from '../../support-buttons/support-buttons.component';

@Component({
  selector: 'app-coming-soon-layout',
  standalone: true,
  imports: [
    HeaderComponent, FooterComponent, SupportButtonsComponent, FaqFooterComponent,
    RouterOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './coming-soon-layout.component.html',
  styleUrl: './coming-soon-layout.component.scss'
})
export class ComingSoonLayoutComponent {

}
